import { useTranslation } from 'libs/i18n'
import { useParams } from 'libs/router'
import { routes } from 'config/routes'
import { BackButton, Header, HistoryTable } from 'shared/components'
import { useFetchSaleHistory } from './queries/useFetchSaleHistory'

const SaleHistoryPage = () => {
	const { t } = useTranslation()
	const params = useParams()
	const { saleHistory, isSaleHistoryLoading } = useFetchSaleHistory()

	return (
		<>
			<Header
				title={t('Sale / History')}
				actions={<BackButton to={routes.saleEdit(params.id)} />}
			/>
			<HistoryTable results={saleHistory?.data} isLoading={isSaleHistoryLoading} />
		</>
	)
}

export default SaleHistoryPage
